<template lang="pug">

  section.footer-copesa
    a.logo-copesa(href="http://www.grupocopesa.cl/", title="Grupo Copesa", target="_blank")
      img(src="assets/images/logos-white/grupocopesa-alt.svg" width="100").white
    nav
      a(href="http://www.latercera.com/", title="La Tercera", target="_blank")
        img(src="assets/images/logos-white/latercera.svg" ).white
      a.narrow-3(href="http://www.lacuarta.com/", title="La Cuarta", target="_blank")
        img(src="assets/images/logos-white/lacuarta.svg" ).white
      a.narrow-2(href="http://www.lahora.cl/", title="La Hora", target="_blank")
        img(src="assets/images/logos-white/lahora.svg" ).white
      a(href="http://www.diarioconcepcion.cl/", title="Diario Concepción", target="_blank")
        img(src="assets/images/logos-white/diarioconcepcion.svg")
      a.narrow-1(href="http://www.quepasa.cl/", title="Qué Pasa", target="_blank")
        img(src="assets/images/logos-white/quepasa.svg")
      a.narrow-2(href="http://www.paula.cl/", title="Paula", target="_blank")
        img(src="assets/images/logos-white/paula.svg").white
      a.narrow-3(href="http://www.glamorama.cl/", title="Glamorama", target="_blank")
        img(src="assets/images/logos-white/glamorama2.svg" ).white
      a.narrow-2(href="http://www.biut.cl/", title="Biut", target="_blank")
        img(src="assets/images/logos-white/biut.svg" ).white
      a.narrow-3(href="http://www.duna.cl/", title="Duna", target="_blank")
        img(src="assets/images/logos-white/duna.svg" ).white
      a.narrow-3(href="http://www.beethvenfm.cl/", title="Beethoven FM", target="_blank")
        img(src="assets/images/logos-white/beethoven.svg" ).white
      a.narrow-3(href="http://www.radiozero.cl/", title="Radio Zero", target="_blank")
        img(src="assets/images/logos-white/zero.svg").white
      a.narrow-3(href="http://www.disneylatino.com/radio/", title="Radio Disney", target="_blank")
        img(src="assets/images/logos-white/radiodisney.svg")
      a.narrow-3(href="http://www.icarito.cl/", title="Icarito", target="_blank")
        img(src="assets/images/logos-white/icarito.svg").white
</template>

<script lang="js">
  export default  {
    name: 'footer-copesa',
}
</script>

<style scoped lang="scss">
  .footer-copesa {
    align-items: center;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
  nav{
    grid-column: span 2;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(20px, 1fr));
    grid-auto-rows: 40px;
    grid-gap: 1rem;
    align-items: center;
    img{
      max-width: 100%;
      max-height: 100%;
    }
    a {
      grid-column: span 4;
    }
    .narrow-1 {
      grid-column: span 1;
    }
    .narrow-2{
      grid-column: span 2;
    }
    .narrow-3{
      grid-column: span 3;
    }
  }

</style>
